import { render, staticRenderFns } from "./FaceDeviceUpdate.vue?vue&type=template&id=0d08bcab&scoped=true&"
import script from "./FaceDeviceUpdate.vue?vue&type=script&lang=js&"
export * from "./FaceDeviceUpdate.vue?vue&type=script&lang=js&"
import style0 from "./FaceDeviceUpdate.vue?vue&type=style&index=0&id=0d08bcab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d08bcab",
  null
  
)

export default component.exports